import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    Alert,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import loginBackground from '../assets/images/background.png';
import logoDark from '../assets/images/logo-dark.svg';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const { setAuth } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post('/login', { username, password });
            setAuth({ ...response.data, username });
            setMessage('Inicio de sesión exitoso.');
            navigate('/dashboard');
        } catch (error) {
            console.error('Error de inicio de sesión', error);
            setMessage('Error al iniciar sesión. Verifica tus credenciales.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                backgroundImage: `linear-gradient(rgba(10, 25, 47, 0.55), rgba(10, 25, 47, 0.55)), url(${loginBackground})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    width: '100%',
                    maxWidth: 420,
                    p: 4,
                    borderRadius: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backdropFilter: 'blur(2px)',
                }}
            >
                <Box
                    component="img"
                    src={logoDark}
                    alt="LANDI"
                    sx={{ height: 38, mb: 1.5 }}
                />
                <Avatar sx={{ mb: 1.5, bgcolor: 'primary.main', width: 48, height: 48 }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h6" color="text.secondary" sx={{ mb: 2 }}>
                    Iniciar sesión
                </Typography>

                {message && (
                    <Alert severity={message.includes('Error') ? 'error' : 'success'} sx={{ width: '100%', mb: 2 }}>
                        {message}
                    </Alert>
                )}

                <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Usuario"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={loading}
                        sx={{ mt: 3 }}
                    >
                        {loading ? 'Ingresando...' : 'Entrar'}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default Login;
